import { TabLayout } from "../layouts/TabLayout";
import { SotdaMyScreen } from "../redesign/live/MyScreen";

// MY 탭 — 클로드디자인 교체본(SotdaMyScreen)으로 렌더.
// 프로필·BULL 경제·등급·설정 = 시안 정적값 (MY 탭 API 미보유, 추후 배선).
// onboarding 화면은 별도 /onboarding 라우트(OnboardingPage)로 분리.
// design doc: 2026-05-22-sotda-ia-restructure §4 Phase E
export function MyPage() {
  return (
    <TabLayout page="my">
      <SotdaMyScreen />
    </TabLayout>
  );
}
